<div class="d-flex mb-2">
  <h1 class="mt-3" style="height: 7%">Stats</h1>
  <div class="w-75 mb-3 align-self-end mr-1">
    <div class="d-flex border rounded shadow-sm proficiency float-right w-50">
      <div class="w-25 border-right rounded text-center bg-white text-center">
        <input type="number" class="form-control w-100 h-100 stat-input" #inspirationInput
               (keyup.enter)="updateInspiration(inspirationInput.value); $event.target.blur()"
               placeholder="{{character.inspiration}}">
      </div>
      <div class="w-75 my-auto text-center">Inspiration</div>
    </div>
  </div>
</div>
<hr>
<div *ngIf="character" class="no-scrollbar" style="height: 86%">

  <div class="card shadow-sm pt-2 pb-2 pl-2 mr-2 mt-3">
    <h6 class="mx-auto">Base Stats</h6>
    <hr class="mr-2">
    <div class="d-flex justify-content-around mt-2 mr-1">
      <div class="card stats pr-2 pl-2" *ngFor="let stat of baseStats | keyvalue">
        <div class="d-flex justify-content-center w-100 h-25 mt-1 border-bottom">
          {{stat.key}}
        </div>
        <div class="d-flex justify-content-center text-center mb-1">
          <input type="number" class="form-control stat-input mt-1" #statInput
                 (keyup.enter)="updateStat(stat.key, statInput.value); $event.target.blur()"
                 placeholder="{{stat.value}}">
        </div>
        <div class="text-center border-top">
          <span>{{abilityModifiers.get(stat.key) >= 0 ? '+' : ''}}{{abilityModifiers.get(stat.key)}}</span>
        </div>
      </div>
    </div>
  </div>

  <!--  [ngClass]="proficiencies.includes(stat.key) ? 'proficiencySkill' : 'nonProficiencySkill'"-->

  <div class="card shadow-sm mr-2 pt-2 pl-2 pb-2 mb-3 mt-3">
    <h6 class="mx-auto">Saving Throws</h6>
    <hr class="mr-2">
    <div class="d-flex justify-content-around mt-2">
      <div *ngFor="let stat of baseStats | keyvalue"
           class="card text-center w-25 mr-2 pr-2 pl-2" (click)="editProficiency(stat.key)">
        <div>{{abilityModifiers.get(stat.key) >= 0 ? '+' : ''}}{{abilityModifiers.get(stat.key) + character.proficiency}}
        </div>
        <div class="border-top">{{stat.key}}</div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm mr-2 pt-2 pl-2 pb-2 mb-3 mt-3">
    <h6 class="mx-auto">Combat Stats</h6>
    <hr class="mr-2">

    <div class="d-flex justify-content-around mt-2">
      <div class="card text-center w-25 mr-2 pr-2 pl-2">
        <div class="d-flex">
          <input type="number" class="form-control stat-input my-auto" #currentHpInput
                 (keyup.enter)="updateCurrentHp(currentHpInput.value); $event.target.blur()"
                 [value]="character.currentHp">
          <span class="p-2">/</span>
          <input type="number" class="form-control stat-input my-auto" #hpInput
                 (keyup.enter)="updateHP(hpInput.value); $event.target.blur()" [value]="character.hp">
        </div>
        <div class="border-top">HP</div>
      </div>

      <div class="card text-center w-25 mr-2 pr-2 pl-2">
        <input type="number" class="form-control stat-input my-auto mx-auto" #acInput (focus)="speedInput.value=''"
               (keyup.enter)="updateAC(acInput.value); $event.target.blur()"
               [value]="character.armorClass">
        <div class="border-top">AC</div>
      </div>

      <div class="card text-center w-25 mr-2 pr-2 pl-2">
        <input type="number" class="form-control stat-input mx-auto"
               #speedInput (keyup.enter)="updateSpeed(speedInput.value); $event.target.blur()"
               [value]="character.speed">
        <div class="border-top">Speed</div>
      </div>

      <div class="card text-center w-25 mr-2 pr-2 pl-2">
        <div class="my-auto">{{abilityModifiers.get('Dex')}}</div>
        <div class="border-top">Initiative</div>
      </div>
    </div>

    <div class="d-flex justify-content-between w-100 mt-2 mx-auto">
      <div class="card text-center mr-2 pr-2 pl-2" style="width: 47%">
        <div class="my-auto">{{character.hitDice}}</div>
        <div class="border-top">Hit Dice</div>
      </div>

      <div class="card text-center mr-2 pr-2 pl-2" style="width: 47%">
        <div class="my-auto">{{passivePerception}}</div>
        <div class="border-top">Passive Perception</div>
      </div>
    </div>
  </div>

  <div class="card p-2 mr-2">
    <h6 class="mx-auto">Skills</h6>
    <hr>

    <div class="w-100 mt-2">
      <div class="d-flex border rounded shadow-sm proficiency float-right" style="width: 35%">
        <div class="w-25 border-right rounded text-center bg-white text-center">
          <input type="number" class="form-control w-100 h-100 stat-input" #proficiencyInput
                 (keyup.enter)="updateProficiency(proficiencyInput.value); $event.target.blur()"
                 placeholder="{{character.proficiency}}">
        </div>
        <div class="w-75 my-auto text-center">Proficiency</div>
      </div>
    </div>

<!--    if prof includes skill, add small P icon or something-->
<!--    maybe click hollow P to add prof-->

    <div *ngFor="let skill of skills | keyvalue" class="mt-4">
      <h6 class="m-0">{{skill.key}}</h6>
      <div class="d-flex justify-content-start flex-wrap">
        <div *ngFor="let skillValue of skill.value" class="card text-center mt-2 mr-1 pr-2 pl-2"
             style="width: 32%; max-height: 20%">
          <div class="my-auto">
            {{proficiencies.includes(skillValue) ? abilityModifiers.get(skill.key) + character.proficiency :
            abilityModifiers.get(skill.key)}}
          </div>
          <div class="border-top" (click)="editProficiency(skillValue)">{{skillValue}}</div>
        </div>
      </div>
    </div>
    <!--    <div [ngClass]="proficiencies.includes(skillValue) ? 'proficiencySkill' : 'nonProficiencySkill'"-->
    <!--         class="border-top" (click)="editProficiency(skillValue)">{{skillValue}}-->
    <!--    </div>-->
  </div>
</div>
